import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/auth.service';
import { OptionService } from 'src/app/options/option.service';
import { UsersService } from 'src/app/options/users/users.service';
import { PermissionService } from 'src/app/systemsettings/permissions/permission.service';
import { menuPerm } from '../menuPerm.model';
import { DirectChargeService } from 'src/app/options/direct-charge-orders/direct-charge.service';


@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit, OnChanges {

  userFullName: string = "";
  role: string = "";
  roleId!: string;
  menuPerm: menuPerm[] = [];
  notSeenMessageCount = 0;
  notSeenDirectChargeCount = 0;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  direction!: any;
  constructor(private breakpointObserver: BreakpointObserver,
    private localStorage: LocalStorageService,
    private authService: AuthService,
    private permissionService: PermissionService,
    private optionService: OptionService,
    private userService: UsersService,
    private router: Router,
    private direcChargeService: DirectChargeService,
    private translate: TranslateService) { }

  ngOnInit(): void {
    // alert(1);
    this.userFullName = this.localStorage.retrieve("userInfo").fullName;
    this.role = this.localStorage.retrieve("userInfo").role;
    this.roleId = this.localStorage.retrieve("userInfo").roleId;
    this.getUserById();
    this.selectChange();
    this.getMenu();
    // this.getNotSeenMessageCount()
    // this.getNotSeenDirectChargeCount();
    // setInterval(() => this.getNotSeenMessageCount(), 30000);

    // setInterval(() =>

    //   this.getNotSeenDirectChargeCount(),

    //   30000);
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes)
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.

  }

  getNotSeenMessageCount() {
    this.optionService.getNotSeenMessageCount().subscribe(data => {
      this.notSeenMessageCount = data;
    }, error => {
      console.log(error);
    })
  }

  onClickMessages() {
    this.updateMessagesSeen();
  }

  updateMessagesSeen() {
    this.optionService.updateNotSeenMessage().subscribe(data => {
      this.getNotSeenMessageCount();
    },
      error =>
        console.log(error))
  }

  selectChange() {
    var body = document.getElementsByTagName('body')[0];
    var html = document.getElementsByTagName('html')[0];
    body.removeAttribute("dir");
    html.removeAttribute("dir");
    this.localStorage.retrieve("lang") == 0 ? this.direction = "ltr" : this.direction = "rtl";
    this.localStorage.retrieve("lang") == 0 ? this.translate.use('en') : this.translate.use('ar');

    if (this.localStorage.retrieve("lang") == 0) {

      body.setAttribute("dir", "ltr");
      html.setAttribute("dir", "ltr");
    }
    else {
      body.setAttribute("dir", "rtl");
      html.setAttribute("dir", "rtl");
    }

  }

  logout() {
    this.authService.logout();
  }

  getMenu() {
    this.permissionService.getMenu(this.roleId).subscribe(data => {
      this.menuPerm = data;
    }, error => {
      console.log(error);
    })
  }

  getUserById() {
    var userId = this.localStorage.retrieve("userInfo").userId;
    this.userService.getUserById(userId).subscribe(data => {

    }, error => {
      console.log(error)
      if (error.status == 401) {

        this.router.navigate(['']);
      }
    })
  }

  getNotSeenDirectChargeCount() {
    this.direcChargeService.getNotSeenCount().subscribe(data => {
      this.notSeenDirectChargeCount = data;
    }, error => {
      console.log(error);
    })
  }

  updateDirectChargeSeen() {
    this.direcChargeService.updateNotSeen().subscribe(data => {
      this.getNotSeenDirectChargeCount();
    },
      error =>
        console.log(error))
  }

  onClickDirectCharge() {
    this.updateDirectChargeSeen();
  }

}
